<template>
  <a-card :bordered="false">
    <a-form>
      <search-header :col="3">
        <search-list>
          <a-form-item label="所属商家" v-bind="searchItemLayout">
            <a-input v-model="queryParams.businessName" placeholder="请输入"></a-input>
          </a-form-item>
          <a-form-item style="margin-left:20px;">
            <a-button type="primary" @click="searchBtn">查询</a-button>
          </a-form-item>
        </search-list>
      </search-header>
    </a-form>
    <custom-page-table
      ref="table"
      :queryParams="queryParams"
      :columns="columns"
      :request-promise="loadPromise"
    >
      <span slot="action" slot-scope="rowItem">
        <a v-if="rowItem.record.status === 1" @click="updateStatus(rowItem.record,0)">显示</a>
        <a v-else @click="updateStatus(rowItem.record,1)">隐藏</a>
        <a-divider type="vertical"></a-divider>
        <a-popconfirm title="是否要删除本条数据？" @confirm="deleteEvent(rowItem.record)">
          <a>删除</a>
        </a-popconfirm>
      </span>
    </custom-page-table>
  </a-card>
</template>

<script>
import searchForm from '../../../../utils/mixins/searchFormMixins'

export default {
  name: 'EvaluationList',
  mixins: [searchForm],
  data() {
    return {
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          width: '60px'
        },
        {
          title: '评价内容',
          dataIndex: 'content'
        },
        {
          title: '整体评价',
          dataIndex: 'convertScore',
          width: '90px'
        },
        {
          title: '评价时间',
          dataIndex: 'gmtCreate',
          width: '160px'
        },
        {
          title: '评价人',
          dataIndex: 'commentName',
          width: '100px'
        },
        {
          title: '所属商家',
          dataIndex: 'businessName',
          width: '160px'
        },
        {
          title: '状态',
          dataIndex: 'converseStatus',
          width: '80px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      loadPromise: params => this.getListPromise(params),
      queryParams: {
        businessName: ''
      },
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'ShopEvaluateList', title: '商家管理' },
      { name: 'EvaluationList', title: '评价管理' }
    ])
  },
  methods: {
    searchBtn() {
      this.$refs.table.refresh(true)
    },
    deleteEvent(record) {
      let params = {
        status: 3,
        commentId: record.id,
        businessId: record.businessId
      }
      this.getHttpServices().getServerApiService().post('v2/comment-content/delete', params)
        .then(res => {
          this.$refs.table.refresh()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    updateStatus(record, type) {
      let params = {
        status: type,
        commentId: record.id,
        businessId: record.businessId
      }
      this.getHttpServices().getServerApiService().post('v2/comment-content/update', params)
        .then(res => {
          this.$message.success('编辑成功')
          this.$refs.table.refresh()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getListPromise(params) {
      params.merchantId = this.merchantId
      params.platformId = this.platformId
      return this.getHttpServices().getServerApiService().post('v2/comment-content/list', params)
    }
  }
}
</script>

<style lang="less" scoped>

</style>